import cx from 'classnames'
import PropTypes from 'prop-types'
import useReloadKey from '~/utils/hooks/useReloadKey'
import GenericInstrumentBody from '../GenericInstrumentBody'
import GenericInstrumentPage from '../GenericInstrumentPage'

import cs from './vspin_instrument_page.scss'

const VspinInstrumentPage = ({ className, status, live, instrument }) => {
  const [reloadKey, refreshReloadKey] = useReloadKey()

  const handleControlCommandComplete = commandName => {
    if (
      commandName === 'load_plate' ||
      commandName === 'unload_plate' ||
      commandName === 'refresh_item_cache_command'
    ) {
      refreshReloadKey()
    }
  }

  const renderBodyContents = () => {
    return (
      <GenericInstrumentBody
        instrument={instrument}
        reloadKey={reloadKey}
        views={['storage', 'transfer_stations', 'list']}
        defaultView='storage'
        className={cs.bodyContents}
        transferStationNameOrder='desc'
      />
    )
  }

  return (
    <div className={cx(className, cs.vspinInstrumentPage)}>
      <GenericInstrumentPage
        instrument={instrument}
        bodyContents={renderBodyContents()}
        status={status}
        live={live}
        onControlCommandComplete={handleControlCommandComplete}
        className={cs.genericInstrumentPage}
      />
    </div>
  )
}

VspinInstrumentPage.propTypes = {
  className: PropTypes.string,
  instrument: PropTypes.shape({
    instrumentName: PropTypes.string,
    instrumentType: PropTypes.string,
  }),
  status: PropTypes.shape({
    execution_state: PropTypes.oneOf(['FAULTED', 'DISCONNECTED', 'BUSY', 'READY']),
    driver_state: PropTypes.oneOf(['STOPPED', 'RUNNING']),
  }),
  live: PropTypes.bool,
}

export default VspinInstrumentPage
